module.exports = __webpack_public_path__ + "static/media/tutorial-draw-risk-1.5f39c0c1.png";